/*
 * Product card color swatches (see snippets/color-swatches.liquid).
 * Clicking a swatch swaps the card's image area (image, hover image, link, quick buy), title link and price
 * with the hidden <template> rendered for that color.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-card-swatch]');

  if (!button) {
    return;
  }

  const card = button.closest('product-card');
  const template = card?.querySelector(`template[data-swatch-template="${button.dataset.cardSwatch}"]`);

  if (!card || !template) {
    return;
  }

  event.preventDefault();

  const content = template.content.cloneNode(true);
  const newFigure = content.querySelector('.product-card__figure');
  const oldFigure = card.querySelector(':scope > .product-card__figure');

  if (newFigure && oldFigure) {
    oldFigure.replaceWith(newFigure);
  }

  const newPrice = content.querySelector('price-list');
  const oldPrice = card.querySelector('.product-card__title-price price-list');

  if (newPrice && oldPrice) {
    oldPrice.replaceWith(newPrice);
  }

  const title = card.querySelector('.product-card__title-price .product-title');

  if (title) {
    title.href = template.dataset.url;
    title.textContent = template.dataset.title;
  }

  card.setAttribute('handle', template.dataset.handle);

  card.querySelectorAll('[data-card-swatch]').forEach((swatch) => {
    const isActive = swatch === button;
    swatch.classList.toggle('is-active', isActive);
    swatch.setAttribute('aria-pressed', String(isActive));
  });
});
